import { useTitle } from "libs/useTitle";
import React from "react";
import { contentDE } from "./contentDE";
import { useSelector } from "react-redux";
import { userSelectors } from "features/userSlice";
import { contentFR } from "./contentFR";
import { contentIT } from "./contentIT";

export const InstructionsForUsePage = () => {
    const language = useSelector(userSelectors.language);
    const title = {
        'de': 'Nutzungshinweise',
        'fr': "Directives d'utilisation de notre site",
        'it': "Suggerimenti per l'uso"
    }
    const content = {
        'de': contentDE,
        'fr': contentFR,
        'it': contentIT
    }

    useTitle(title[language]);

    return <>
        <div className="container-fluid policy-page">
            {content[language]}
        </div>
    </>
}